import React from 'react';

interface SkeletonProps {
  className?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({ className = '' }) => (
  <div
    className={`bg-gray-200 rounded animate-shimmer ${className}`}
    style={{ backgroundImage: 'linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%)', backgroundSize: '200% 100%' }}
  />
);

export const CardSkeleton: React.FC = () => (
  <div className="bg-white p-5 rounded-lg shadow">
    <Skeleton className="h-4 w-24 mb-2" />
    <Skeleton className="h-8 w-16" />
  </div>
);

export const TableSkeleton: React.FC<{ rows?: number }> = ({ rows = 5 }) => (
  <div className="space-y-3">
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="flex gap-4">
        <Skeleton className="h-4 flex-1" />
        <Skeleton className="h-4 w-20" />
        <Skeleton className="h-4 w-16" />
        <Skeleton className="h-4 w-24" />
      </div>
    ))}
  </div>
);

export const PageSkeleton: React.FC = () => (
  <div>
    <Skeleton className="h-8 w-48 mb-6" />
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      <CardSkeleton />
      <CardSkeleton />
      <CardSkeleton />
      <CardSkeleton />
    </div>
    <div className="bg-white p-6 rounded-lg shadow">
      <Skeleton className="h-6 w-32 mb-4" />
      <TableSkeleton />
    </div>
  </div>
);
